import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllOrders, setSelectedOrdersPreCheck } from '../../store/orders/selected-orders/orders.selected-orders.actions';

import Global from '../../store/global-selectors';

import SelectAllBannerComponent from './component';
import { ALL_ORDERS_PAGE_VIEWS } from '../../pages/orders-page/orders-page-view-constants';
import { useTopLevelOrdersViewId } from '../../pages/orders-page/orders-left-nav/orders-left-nav-context';

const SelectAllBanner = () => {
  const dispatch = useDispatch();
  const selectedCount = useSelector(Global.selectSelectedOrdersIds)?.length || 0;
  const totalCount = useSelector(Global.selectOrdersGridTotalRecords) || 0;
  const viewId = useTopLevelOrdersViewId();
  const view = ALL_ORDERS_PAGE_VIEWS.find((v) => v.id === viewId);
  const [areAllSelected, setAreAllSelected] = useState(false);

  const toggleAreAllSelected = useCallback(() => {
    if (!areAllSelected) {
      dispatch(selectAllOrders());
    } else {
      dispatch(setSelectedOrdersPreCheck([]));
    }

    setAreAllSelected(!areAllSelected);
  }, [areAllSelected, setAreAllSelected, dispatch]);

  return (
    <SelectAllBannerComponent
      areAllSelected={areAllSelected}
      gridStatusText={view?.label}
      selectedCount={selectedCount}
      toggleAreAllSelected={toggleAreAllSelected}
      totalCount={totalCount}
    />
  );
};

export default SelectAllBanner;
